import React from "react";
import ThisOrThat from "../Games/ThisOrThat";
import { useTheme } from "@mui/material/styles";

const SmartMoneyThisOrThat = () => {
  const theme = useTheme();

  const FINANCIAL_PAIRS = [
    { left: "💰 Save for emergency fund", right: "💳 Pay down debt" },
    { left: "🏠 Buy a house", right: "📈 Invest in stocks" },
    { left: "🎓 Student loans", right: "🚗 Car payment" },
    { left: "💳 Credit card", right: "💵 Debit card" },
    { left: "📱 Digital banking", right: "🏦 Branch banking" },
    { left: "📊 Index funds", right: "🎯 Individual stocks" },
    { left: "🏦 High-yield savings", right: "📈 Stock market" },
    { left: "🎓 College fund", right: "🏠 Down payment" },
    { left: "🚗 New car", right: "🚘 Used car" },
    { left: "💳 Pay in full", right: "💳 Minimum payment" },
  ];

  return (
    <ThisOrThat
      pairs={FINANCIAL_PAIRS}
      brandColors={{
        primary: theme.palette.primary.main,
        secondary: theme.palette.secondary.main,
        background: theme.palette.background.default,
        text: "white",
        success: "rgba(40, 180, 99, 0.32)",
        neutral: "rgba(60, 80, 180, 0.28)",
        progressBg: "#f3f3fa",
        white: "#fff",
        black: "#000",
      }}
    />
  );
};

export default SmartMoneyThisOrThat;
